/**
 * Validação dos parâmetros de busca das rotas, sem zod: o roteador entra no carregamento inicial e o zod não.
 * Valor inválido vira ausente (como o `.optional().catch(undefined)` de antes): um endereço mexido abre a tela no padrão.
 */
type Validador<T> = (v: unknown) => T | undefined;

export function busca<V extends Record<string, Validador<unknown>>>(campos: V) {
  return (s: Record<string, unknown>): { [K in keyof V]?: Exclude<ReturnType<V[K]>, undefined> } => {
    const r: Record<string, unknown> = {};
    for (const k in campos) {
      const v = campos[k]!(s[k]);
      if (v !== undefined) r[k] = v;
    }
    return r as never;
  };
}

export const opcao =
  <const T extends readonly string[]>(lista: T): Validador<T[number]> =>
  (v) =>
    typeof v === "string" && lista.includes(v) ? (v as T[number]) : undefined;

export const texto =
  (maximo = Infinity, formato?: RegExp): Validador<string> =>
  (v) =>
    typeof v === "string" && v.length <= maximo && (!formato || formato.test(v)) ? v : undefined;

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const uuid: Validador<string> = (v) => (typeof v === "string" && UUID.test(v) ? v : undefined);

/** Data "aaaa-mm-dd" que existe no calendário. */
export const data: Validador<string> = (v) => {
  if (typeof v !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return undefined;
  const d = new Date(`${v}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().startsWith(v) ? v : undefined;
};

/** Número de página: inteiro a partir de 1 (no endereço pode vir como texto). */
export const pagina: Validador<number> = (v) => {
  const n = typeof v === "number" ? v : typeof v === "string" && v.trim() !== "" ? Number(v) : NaN;
  return Number.isInteger(n) && n >= 1 ? n : undefined;
};
